import { render, staticRenderFns } from "./cases.vue?vue&type=template&id=bc1ead40&scoped=true&"
import script from "./cases.vue?vue&type=script&lang=js&"
export * from "./cases.vue?vue&type=script&lang=js&"
import style0 from "./cases.vue?vue&type=style&index=0&id=bc1ead40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1ead40",
  null
  
)

export default component.exports